import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PublicHeader = ({ phoneDisplay = "0455 530 779", phoneTel = "+61455530779" }) => {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-border" data-testid="public-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
          <img src="/brand/logo.jpg" alt="Blake's Mowing and Odd Jobs logo" className="h-10 w-10 rounded-full object-cover" data-testid="header-logo" />
          <span className="font-display font-bold text-base sm:text-lg tracking-tight leading-tight">Blake&apos;s Mowing &amp; Odd Jobs</span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <a href="/#services" className="hidden sm:inline-block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-services-link">
            Services
          </a>
          <Link to="/book" data-testid="nav-book-link">
            <Button variant="outline" className="rounded-full border-primary text-primary hover:bg-primary hover:text-white transition-colors">
              Book a Job
            </Button>
          </Link>
          <a href={`tel:${phoneTel}`} data-testid="nav-call-button">
            <Button className="rounded-full bg-accent hover:bg-[#B85827] text-white animate-pulse-ring transition-colors">
              <Phone className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">{phoneDisplay}</span>
            </Button>
          </a>
        </nav>
      </div>
    </header>
  );
};
